import api from '../utils/api';

// Fetch all academic years
export const getAcademicYears = async (headers) => {
  try {
    const response = await api.get('/api/academicyears', headers);
    console.log("academic year ", response.data) 
    return response.data;
  } catch (error) {
    console.error('Error fetching academic years:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific academic year by ID
export const getAcademicYearById = async (id, headers) => {
  try {
    const response = await api.get(`/api/academicyears/${id}`, headers );
    console.log("academic year by id", response.data) 
    return response.data;
  } catch (error) {
    console.error(`Error fetching academic year with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new academic year
export const createAcademicYear = async (academicYearData, headers) => {
  try {
    const response = await api.post('/api/academicyears', academicYearData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating academic year:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing academic year
export const updateAcademicYear = async (id, academicYearData, headers) => {
  try {
  const response = await api.put(`/api/academicyears/${id}`, academicYearData, headers );
    return response.data;
  } catch (error) {
    console.error(`Error updating academic year with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete an academic year
export const deleteAcademicYear = async (id, headers) => {
  try {
    const response = await api.delete(`/api/academicyears/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error deleting academic year with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
